import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {RelationArticle} from './relation-article';
import {BaseNumberApi} from '@shared/base/base-number-api';

@Injectable({
  providedIn: 'root'
})
export class RelationArticleApi extends BaseNumberApi<RelationArticle> {
  protected httpClient: HttpClient;


  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient, 'relationarticles');
  
    this.httpClient = httpClient;
  }

  create(): RelationArticle {
    return new RelationArticle();
  }

  public toggle(nr: number): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.endpoint}/${nr}/toggle`);
  }
}
